import React from "react";
import {
	CarOutlined,
	CheckCircleOutlined,
	ClockCircleOutlined,
	CloseCircleOutlined,
	DollarOutlined,
	RollbackOutlined,
} from "@ant-design/icons";
import { OperationConfig } from "../components/OperationCards";

// Rendered from this list so a future backend operation in this category is one
// new entry here. Operation values must match SpeedApi.Core.Enums
// .BulkOrderOperationType — they are frozen wire values.
export const AMK_ORDERS_OPERATIONS: OperationConfig[] = [
	{
		value: "SetInTransport",
		labelKey: "opSetInTransport",
		descriptionKey: "opSetInTransportDesc",
		fallbackLabel: "In transport",
		fallbackDescription: "Set orders to 'in transport'",
		icon: <CarOutlined />,
		supportsComment: true,
	},
	{
		value: "Refuse",
		labelKey: "opRefuse",
		descriptionKey: "opRefuseDesc",
		fallbackLabel: "Refuse",
		fallbackDescription: "Set orders to 'refused'",
		icon: <CloseCircleOutlined />,
		supportsComment: true,
	},
	{
		value: "SetWaiting",
		labelKey: "opSetWaiting",
		descriptionKey: "opSetWaitingDesc",
		fallbackLabel: "Waiting",
		fallbackDescription: "Set orders to 'waiting'",
		icon: <ClockCircleOutlined />,
		supportsComment: true,
	},
	{
		value: "Deliver",
		labelKey: "opDeliver",
		descriptionKey: "opDeliverDesc",
		fallbackLabel: "Deliver",
		// NOTE: "No money moves" is not strictly true — for sellers whose package is
		// Returnable = 1, SelectClientDetailsBalance_sp excludes (14,6) from its returns
		// deduction, so Deliver alone raises their CurrentBalance. Copy left as-is
		// pending a decision; see the 2026-07-27 audit notes.
		//
		// It DOES create orders: an exchangeable/returnable/invoice package owes a child
		// order so the item the buyer hands back is tracked home to the warehouse. Every
		// other delivery path creates one; AMK has no system to call back, so this is it.
		fallbackDescription:
			"Set orders to 'delivered'. No money moves. Creates the exchange/return order when the package needs one.",
		icon: <CheckCircleOutlined />,
		supportsComment: true,
	},
	{
		value: "AddBalance",
		labelKey: "opAddBalance",
		descriptionKey: "opAddBalanceDesc",
		fallbackLabel: "Add balance",
		fallbackDescription:
			"Credits seller balances for delivered orders. Moves money!",
		icon: <DollarOutlined />,
		supportsComment: false,
		danger: true,
	},
	{
		value: "SetReturning",
		labelKey: "opSetReturning",
		descriptionKey: "opSetReturningDesc",
		fallbackLabel: "Returning",
		// Writes both this country's database and the destination country's, in one
		// transaction — the only operation that touches two databases.
		fallbackDescription:
			"Set orders to 'duke u kthyer' here and 'kthyer' in the destination country",
		icon: <RollbackOutlined />,
		supportsComment: true,
	},
];
